export const useAlerts = () => {
  const nuxtApp = useNuxtApp()
  
  return {
    showAlert: nuxtApp.$alerts.showAlert,
    showSuccess: nuxtApp.$alerts.showSuccess,
    showError: nuxtApp.$alerts.showError,
    showWarning: nuxtApp.$alerts.showWarning
  }
}